export default {
  GOOGLE_MAPS: 'AIzaSyCyPw2h5CAEBUk5QQl8yU-s10BHEJVzSsA',
}



// WEBPACK FOOTER //
// ./src/constants/keys.js